import React from 'react';
import { useDispatch } from 'react-redux';
import { editCover, setConfirmDeleteMember } from '@om/redux/actions/easiplusFuneralPlan/quote';
import { OmLabeledValueSummary, OmEfpFamilyMemberCard } from '@om/component-library-react';
import { getValueWithThousandSeperator } from '@om/redux/selectors/sizotsaFuneralCover/quote';

const BenefitsCard = ({
    id,
    cashback,
    premiumPaidUp,
    onDelete,
    coverAmount,
    monthlyPremium,
    deleteEnabled = false,
    onEdit,
}) => {

    return (
        <OmEfpFamilyMemberCard
            expanded
            editEnabled
            deleteEnabled={deleteEnabled}
            addDetailsEnabled
            cardId={id}
            
            onEditDetailsClicked={onEdit}
            onPopupModal={onDelete}
        >
            <h6 className="strong small no-top-margin no-bottom-margin" slot="family-member-card-heading">
                Benefits details
            </h6>
            <div  slot="family-member-card-body">
                {coverAmount && <><OmLabeledValueSummary label="INCOME STABALIZATAION " value={getValueWithThousandSeperator(coverAmount)} />
                <OmLabeledValueSummary label="MONTHLY PREMIUM" value={`${getValueWithThousandSeperator((monthlyPremium?.toFixed(2)))} PM` } />
                <OmLabeledValueSummary label="ANNUAL PREMIUM" value={`${getValueWithThousandSeperator((monthlyPremium*12)?.toFixed(2))} PA`} />
                </> }
                <OmLabeledValueSummary label="CASHBACK" value={cashback} />
                {/* <OmLabeledValueSummary label="PREMIUM PAID UP" value={premiumPaidUp} /> */}
                {/* <OmLabeledValue horizontal={true} horizontalSeparator={': '} label="INCOME STABALIZATAION " value={coverAmount} />
                <OmLabeledValue horizontal={true} horizontalSeparator={': '} label="MONTHLY PREMIUM" value={monthlyPremium} />
                <OmLabeledValue horizontal={true} horizontalSeparator={': '} label="ANNUAL PREMIUM" value={monthlyPremium*12??''} />
                <OmLabeledValue horizontal  horizontalSeparator={': '} label="CASHBACK" value={cashback} />
                <OmLabeledValue horizontal horizontalSeparator={': '} label="PREMIUM PAID UP" value={premiumPaidUp} /> */}
            </div>
        </OmEfpFamilyMemberCard>
    );
};

export default BenefitsCard;
